module.exports = __webpack_public_path__ + "static/img/main_user.747dc4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_user.png
// module id = QtCg
// module chunks = 1